import { liveQuery } from 'dexie';
import { useEffect, useState } from 'react';

/** A Dexie live query as React state: re-runs whenever the stores it read change. */
export function useLiveQuery<T>(
  querier: () => Promise<T>,
  initial: T,
  deps: readonly unknown[],
): T {
  const [value, setValue] = useState<T>(initial);
  useEffect(() => {
    const subscription = liveQuery(querier).subscribe({
      next: (result) => {
        setValue(result);
      },
      error: (error: unknown) => {
        console.error('live query failed', error);
      },
    });
    return () => {
      subscription.unsubscribe();
    };
    // The querier closes over `deps`; a new identity per render must not resubscribe.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  return value;
}
